export default __webpack_public_path__ + "static/media/defaultImg.e20282a0.jpg";